import { render, staticRenderFns } from "./WhatAreWeDoing.vue?vue&type=template&id=4f7c2038&scoped=true&"
import script from "./WhatAreWeDoing.vue?vue&type=script&lang=js&"
export * from "./WhatAreWeDoing.vue?vue&type=script&lang=js&"
import style0 from "./WhatAreWeDoing.vue?vue&type=style&index=0&id=4f7c2038&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7c2038",
  null
  
)

export default component.exports